module.exports = __webpack_public_path__ + "img/cs-aboutus-1.3263d49a.jpg";